// @flow
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import states from '../../data/states'
import Input from '../Input'
import Button from '../Button'

type Props = {
  onSubmit: Function,
  submitting: boolean,
  handleSubmit: Function,
  clientId: number
}

class UpdateClientForm extends Component {
  props: Props

  handleSubmit = (data) =>
    this.props.onSubmit(this.props.clientId, { client: data })

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Field
          name="address"
          label="Address"
          component={Input}
          style={{ marginBottom: '1rem' }}
        />
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              name="city"
              label="City"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
          <div className="col-md-6 col-xs-12">
            <div className="row">
              <div className="col-sm-6 col-xs-12">
                <label htmlFor="state">State</label>
                <Field
                  name="state"
                  component="select"
                  className="form-control"
                  style={{ marginBottom: '1rem' }}
                >
                  {states.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </Field>
              </div>
              <div className="col-sm-6 col-xs-12">
                <Field
                  name="zip"
                  label="Zip"
                  component={Input}
                  style={{ marginBottom: '1rem' }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              name="bedrooms"
              type="number"
              label="Bedrooms"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
          <div className="col-md-6 col-xs-12">
            <Field
              name="bathrooms"
              type="number"
              label="Bathrooms"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              name="garage_spaces"
              type="number"
              label="Garage Spaces"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
          <div className="col-md-6 col-xs-12">
            <div style={{ marginBottom: '1rem' }}>
              <label htmlFor="basement_type">Basement Type</label>
              <Field
                name="basement_type"
                component="select"
                className="form-control"
              >
                <option value="None">None</option>
                <option value="Finished">Finished</option>
                <option value="Unfinished">Unfinished</option>
              </Field>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <Field
              name="area"
              type="number"
              label="Living Area Square Feet"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
          <div className="col-md-6 col-xs-12">
            <Field
              name="year_built"
              type="number"
              label="Year Built"
              component={Input}
              style={{ marginBottom: '1rem' }}
            />
          </div>
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label htmlFor="notes" style={{ marginRight: '10px' }}>
            Notes
          </label>
          <small style={{ color: 'rgb(185,187,191)' }}>
            (additional features, recent updates)
          </small>
          <Field
            name="notes"
            component="textarea"
            rows={6}
            className="form-control"
          />
        </div>
        <Button color="primary" disabled={submitting} animating={submitting}>
          Submit
        </Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'updateClient'
})(UpdateClientForm)



// WEBPACK FOOTER //
// ./src/components/UpdateClientForm/index.js